import React from "react";
import { Link } from "react-router-dom";
import Reveal from "./Reveal";

export default function AboutSection() {
  return (
    <section id="about" className="about section">
      <div className="container">
        <p className="eyebrow">01 — ABOUT RYU</p>
        <div className="intro-grid">
          <Reveal>
            <h2>
              一本の先に、
              <br />
              ビジネスがある。
            </h2>
          </Reveal>
          <Reveal className="intro-copy" delay={100}>
            <p className="intro-lead">
              選ぶ力。届ける力。
              <br />
              その先の販売まで、つなぐ力。
            </p>
            <p>
              RYU株式会社は、酒類を軸に卸売・EC・流通を展開する企業です。飲食店、小売店、法人のお客様へ。仕入れから販売までを見渡し、それぞれのビジネスに応える商品と供給を考えます。
            </p>
            <Link className="text-link" to="/company">
              RYUについて <span>↗</span>
            </Link>
          </Reveal>
        </div>
        <div className="intro-band">
          <span>PRODUCT</span>
          <i>×</i>
          <span>SUPPLY</span>
          <i>×</i>
          <span>MARKET</span>
        </div>
      </div>
    </section>
  );
}
